export const GET_OFFLINEPAYMENT_LOADING= "GET_OFFLINEPAYMENT_LOADING";
export const GET_OFFLINE_SUCCESS ="GET_OFFLINE_SUCCESS";
export const GET_OFFLINE_FAIL="GET_OFFLINE_FAIL";
export const GET_ALLOFFLINE_SUCCESS="GET_ALLOFFLINE_SUCCESS";
export const GET_ALLOFFLINEPAYMENT_LOADING="GET_ALLOFFLINEPAYMENT_LOADING";
export const GET_ALLOFFLINE_FAIL="GET_ALLOFFLINE_FAIL";
